module.exports = __webpack_public_path__ + "img/vertical-align-middle.6290edc1.svg";